import React, { useState, useEffect } from 'react'
import { Grid, TextField, Typography } from '@material-ui/core'

function ChromosomeFilterModal({ value = '', onChange, onClose }) {
  const [localValue, setLocalValue] = useState(value)

  // Update local state when prop changes
  useEffect(() => {
    setLocalValue(value)
  }, [value])

  // Update parent state whenever localValue changes
  useEffect(() => {
    console.log('Chromosome filter value changed:', localValue)
    onChange(localValue)
  }, [localValue, onChange])

  console.log('ChromosomeFilterModal received value:', value, 'localValue:', localValue)

  const handleChange = (e) => {
    console.log('Chromosome filter changed locally:', e.target.value)
    setLocalValue(e.target.value)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Chromosome Filter
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Enter chromosome number or range (e.g., "1", "X", "1-5", "X,Y").
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          value={localValue}
          onChange={handleChange}
          variant="outlined"
          placeholder="Enter chromosome(s)"
          fullWidth
          helperText="Examples: 1, 2, X, Y, 1-5, X,Y"
        />
      </Grid>
    </Grid>
  )
}

export default ChromosomeFilterModal
